<template>
  <b-modal
    hide-footer
    id="modal-add-committee"
    ref="modal-add-committee"
    size="xl"
    title="เพิ่มอนุกรรมการ"
  >
    <div class="container">
      <b-overlay :show="showOverlay" rounded="sm">
        <b-card>
          <b-row>
            <b-card class="mt-2 col-12">
              <b-col cols="12">
                <SearchFilter
                  :mode="'List'"
                  :autoSearch="true"
                  ref="searchFilterModal"
                  @handleSubmit="searchFilterSubmit"
                />
              </b-col>
            </b-card>

            <b-col cols="12" class="row">
              <b-col md="6" class="d-flex justify-content-center">
                <b-form-group
                  label="หน่วยงาน"
                  label-for="dep"
                  class="w-100 pl-2"
                >
                  <b-form-input
                    type="text"
                    :readonly="true"
                    v-model="departmentName"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6" class="d-felx justify-content-end">
                <b-form-group label="สิทธิ์" label-for="role">
                  <vue-select
                    label="text"
                    v-model="roleSelect"
                    :options="roles"
                    @input="selectOnInput"
                    :clearable="false"
                  />
                </b-form-group>
              </b-col>
            </b-col>

            <b-col cols="12">
              <CommonTable
                @handle-select="onSelectChange"
                @handleOverlay="setOverlay"
                ref="tableCommon"
              >
              </CommonTable>
            </b-col>
          </b-row>
          <footer
            id="modal-transfer___BV_modal_footer_"
            class="modal-footer d-flex justify-content-between"
          >
            <button
              type="button"
              class="btn btn-secondary"
              block
              @click="onCancel"
            >
              ยกเลิก
            </button>
            <button
              type="button"
              class="btn btn-primary"
              block
              @click="onSubmit"
            >
              เพิ่มผู้ใช้งาน
            </button>
          </footer>
        </b-card>
      </b-overlay>
    </div>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BModal,
  BButton,
  BFormTextarea,
  BOverlay,
  BCard,
} from "bootstrap-vue";

import VueSelect from "vue-select";

import CommonTable from "./CommonTableModal";
import SearchFilter from "./SearchFilterModal";
import * as subcommitteeStore from "@/store/api/subcommittee/index.js";
import * as roleStore from "@/store/api/role/index.js";
import * as departmentRoleStore from "@/store/api/role/departmentRole.js";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    BCard,
    BOverlay,
    VueSelect,
    CommonTable,
    SearchFilter,
  },
  props: {
    departmentId: null,
    departmentName: null,
    roleId: null,
  },
  data() {
    return {
      datasuggest: [],
      filteredOptions: [],
      inputProps: {
        id: "companyName",
        class: "form-control",
        placeholder: "ผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)",
      },
      limit: 10,
      selects: [],
      showOverlay: false,
      roleSelect: null,
      roles: [],
      selectedRows: [],
      newSelectedRows: [],
      committeeGroupId: null,
      directorGroupId: null,
    };
  },
  mounted() {
  },
  methods: {
    setModalData(selectedRows, directorGroupId) {
      console.log("directorGroupId", directorGroupId);
      const _this = this;
      this.selectedRows = selectedRows;
      this.directorGroupId = directorGroupId;
      this.newSelectedRows = selectedRows;

      setTimeout(() => {
        // console.log("ref", _this.$refs);
        // console.log(
        //   "refModal",
        //   _this.$refs["searchFilterModal"],
        //   _this.$refs["modal-add-committee"]
        // );
        // //console.log("setModalData", this.selectedRows, this.directorGroupId);
        // console.log(
        //   "this.$refs.searchFilterModal",
        //   _this.$refs.searchFilterModal
        // );
        this.$refs.searchFilterModal.setDirectorGroupId(this.directorGroupId);
      }, 1000);
    },
    setOverlay(isShow) {
      this.showOverlay = isShow;
    },
    searchFilterSubmit(params) {
      this.directorGroupId = params.groupId;
      this.$refs.tableCommon.onSearchSubmit(params, this.selectedRows);
    },
    onSubmit() {
      var _this = this;

      console.log("onSubmit", this.newSelectedRows);

      /// จะต้องใส่ข้อมูล isActive, isDirector ของข้อมูลเดิมให้
      this.newSelectedRows.forEach((row) => {
        const oldData = _this.selectedRows.find(
          (selectedRow) => selectedRow.committeeData.id === row.committeeData.id
        );
        if (oldData) {
          row.isActive = oldData.isActive;
          row.isDirector = oldData.isDirector;
        } else {
          row.isActive = true; // ถ้าไม่เจอข้อมูลเดิม ให้ตั้งค่าเป็น true
          row.isDirector = false;
        }
      });

      _this.$emit("handle-submit", this.newSelectedRows, this.directorGroupId);
      _this.$refs["modal-add-committee"].hide();
    },
    onCancel() {
      this.$refs["modal-add-committee"].hide();
    },
    onSelectChange(selects) {
      this.newSelectedRows = selects;
    },
    selectOnInput() {
      this.$forceUpdate();
    },
  },
};
</script>

<style></style>
